export const flexiblelife = {
    mounted() {
        this.checkFeatures();
    },
    watch: {
        features() {
            this.checkFeatures();
        },
    },
    methods: {
        checkFeatures() {
            if ("FlexibleLife20" in this.features) {
                this.$store.cache.dispatch(
                    "flexiblelife/getFlexibleLife20",
                    this.contractId
                );
                if (this.getFondsDaten) {
                    this.$store.cache.dispatch(
                        "fonds/getFlexibleLifeFondsDaten20"
                    );
                }
            } else if ("FlexibleLife" in this.features) {
                this.$store.cache.dispatch(
                    "flexiblelife/getFlexibleLife",
                    this.contractId
                );
                if (this.getFondsDaten) {
                    this.$store.cache.dispatch(
                        "fonds/getFlexibleLifeFondsDaten"
                    );
                }
            } else if ("Vollwert" in this.features) {
                this.$store.cache.dispatch(
                    "vollwert/getVollwert",
                    this.contractId
                );
                if (this.getFondsDaten) {
                    this.$store.cache.dispatch("fonds/getVollwertFondsDaten");
                }
            }
        },
    },
    computed: {
        features() {
            let result = {};
            if (
                this.contractId in this.$store.state.contracts &&
                "Features" in this.$store.state.contracts[this.contractId]
            ) {
                result = this.$store.state.contracts[this.contractId].Features;
            }
            return result;
        },
        isVollwert() {
            let result = false;
            if (
                this.$store.state.contracts[this.contractId] &&
                "Vollwert" in
                    this.$store.state.contracts[this.contractId].Features
            ) {
                result = true;
            }
            return result;
        },
        isFlexibleLife20() {
            let result = false;
            if (
                this.$store.state.contracts[this.contractId] &&
                "FlexibleLife20" in
                    this.$store.state.contracts[this.contractId].Features
            ) {
                result = true;
            }
            return result;
        },
        vorsorgeAll() {
            let result = this.$store.state.flexiblelife.all;
            if (this.isVollwert) {
                result = this.$store.state.vollwert.all;
            }
            return result;
        },
        flexiblelife() {
            let result = {};
            if (this.contractId in this.vorsorgeAll) {
                result = this.vorsorgeAll[this.contractId];
            }
            return result;
        },
        vorsorgeText() {
            let result = "flexiblelife";
            if (this.isVollwert) {
                result = "vollwert";
            }
            return result;
        },
        anpassenInfo() {
            var result = "";
            if (
                "infobox" in this.flexiblelife &&
                "anpassen" in this.flexiblelife.infobox
            ) {
                result = this.flexiblelife.infobox.anpassen;
            }
            return result;
        },
        aufstockungInfo() {
            var result = "";
            if (
                "infobox" in this.flexiblelife &&
                "aufstockung" in this.flexiblelife.infobox
            ) {
                result = this.flexiblelife.infobox.aufstockung;
            }
            return result;
        },
        teilentnahmeInfo() {
            var result = "";
            if (
                "infobox" in this.flexiblelife &&
                "teilentnahme" in this.flexiblelife.infobox
            ) {
                result = this.flexiblelife.infobox.teilentnahme;
            }
            return result;
        },
        fondsCategory40() {
            let result = {};
            if (
                this.vorsorgeText in this.flexiblelife &&
                "40" in this.flexiblelife[this.vorsorgeText]
            ) {
                result = this.flexiblelife[this.vorsorgeText]["40"];
            }
            return result;
        },
        fondsCategory65() {
            let result = {};
            if (
                this.vorsorgeText in this.flexiblelife &&
                "65" in this.flexiblelife[this.vorsorgeText]
            ) {
                result = this.flexiblelife[this.vorsorgeText]["65"];
            }
            return result;
        },
        fondsCategory70() {
            let result = {};
            if (
                this.vorsorgeText in this.flexiblelife &&
                "70" in this.flexiblelife[this.vorsorgeText]
            ) {
                result = this.flexiblelife[this.vorsorgeText]["70"];
            }
            return result;
        },
        fondsCategory100() {
            let result = {};
            if (
                this.vorsorgeText in this.flexiblelife &&
                "100" in this.flexiblelife[this.vorsorgeText]
            ) {
                result = this.flexiblelife[this.vorsorgeText]["100"];
            }
            return result;
        },
        flexiblelifeFonds1() {
            let result = {};
            if (
                this.contractId in this.vorsorgeAll &&
                this.vorsorgeText in this.vorsorgeAll[this.contractId] &&
                (("40" in
                    this.vorsorgeAll[this.contractId][this.vorsorgeText] &&
                    "fond1" in
                        this.vorsorgeAll[this.contractId][this.vorsorgeText][
                            "40"
                        ]) ||
                    ("70" in
                        this.vorsorgeAll[this.contractId][this.vorsorgeText] &&
                        "fond1" in
                            this.vorsorgeAll[this.contractId][
                                this.vorsorgeText
                            ]["70"]))
            ) {
                result =
                    this.vorsorgeAll[this.contractId][this.vorsorgeText]["40"]
                        ?.fond1 ||
                    this.vorsorgeAll[this.contractId][this.vorsorgeText]["70"]
                        .fond1;
            }
            return result;
        },
        flexiblelifeFonds2() {
            let result = {};
            if (
                this.contractId in this.vorsorgeAll &&
                this.vorsorgeText in this.vorsorgeAll[this.contractId] &&
                (("40" in
                    this.vorsorgeAll[this.contractId][this.vorsorgeText] &&
                    "fond2" in
                        this.vorsorgeAll[this.contractId][this.vorsorgeText][
                            "40"
                        ]) ||
                    ("100" in
                        this.vorsorgeAll[this.contractId][this.vorsorgeText] &&
                        "fond2" in
                            this.vorsorgeAll[this.contractId][
                                this.vorsorgeText
                            ]["100"]))
            ) {
                result =
                    this.vorsorgeAll[this.contractId][this.vorsorgeText]["40"]
                        ?.fond2 ||
                    this.vorsorgeAll[this.contractId][this.vorsorgeText]["100"]
                        .fond2;
            }
            return result;
        },
        flexiblelifeFonds7() {
            let result = {};
            if (
                this.contractId in this.vorsorgeAll &&
                this.vorsorgeText in this.vorsorgeAll[this.contractId] &&
                "65" in this.vorsorgeAll[this.contractId][this.vorsorgeText] &&
                "fond7" in
                    this.vorsorgeAll[this.contractId][this.vorsorgeText]["65"]
            ) {
                result = this.vorsorgeAll[this.contractId][this.vorsorgeText][
                    "65"
                ].fond7;
            }
            return result;
        },
        flexiblelifeFonds3() {
            let result = {};
            if (
                this.contractId in this.vorsorgeAll &&
                this.vorsorgeText in this.vorsorgeAll[this.contractId] &&
                (("65" in
                    this.vorsorgeAll[this.contractId][this.vorsorgeText] &&
                    "fond3" in
                        this.vorsorgeAll[this.contractId][this.vorsorgeText][
                            "65"
                        ]) ||
                    ("70" in
                        this.vorsorgeAll[this.contractId][this.vorsorgeText] &&
                        "fond3" in
                            this.vorsorgeAll[this.contractId][
                                this.vorsorgeText
                            ]["70"]))
            ) {
                result =
                    this.vorsorgeAll[this.contractId][this.vorsorgeText]["65"]
                        ?.fond3 ||
                    this.vorsorgeAll[this.contractId][this.vorsorgeText]["70"]
                        .fond3;
            }
            return result;
        },
        flexiblelifeFonds4() {
            let result = {};
            if (
                this.contractId in this.vorsorgeAll &&
                this.vorsorgeText in this.vorsorgeAll[this.contractId] &&
                (("65" in
                    this.vorsorgeAll[this.contractId][this.vorsorgeText] &&
                    "fond4" in
                        this.vorsorgeAll[this.contractId][this.vorsorgeText][
                            "65"
                        ]) ||
                    ("100" in
                        this.vorsorgeAll[this.contractId][this.vorsorgeText] &&
                        "fond4" in
                            this.vorsorgeAll[this.contractId][
                                this.vorsorgeText
                            ]["100"]))
            ) {
                result =
                    this.vorsorgeAll[this.contractId][this.vorsorgeText]["65"]
                        ?.fond4 ||
                    this.vorsorgeAll[this.contractId][this.vorsorgeText]["100"]
                        .fond4;
            }
            return result;
        },
        flexiblelifeFonds5() {
            let result = {};
            if (
                this.contractId in this.vorsorgeAll &&
                this.vorsorgeText in this.vorsorgeAll[this.contractId] &&
                "100" in this.vorsorgeAll[this.contractId][this.vorsorgeText] &&
                "fond5" in
                    this.vorsorgeAll[this.contractId][this.vorsorgeText]["100"]
            ) {
                result = this.vorsorgeAll[this.contractId][this.vorsorgeText][
                    "100"
                ].fond5;
            }
            return result;
        },
        flexiblelifeFonds6() {
            let result = {};
            if (
                this.contractId in this.vorsorgeAll &&
                this.vorsorgeText in this.vorsorgeAll[this.contractId] &&
                "100" in this.vorsorgeAll[this.contractId][this.vorsorgeText] &&
                "fond6" in
                    this.vorsorgeAll[this.contractId][this.vorsorgeText]["100"]
            ) {
                result = this.vorsorgeAll[this.contractId][this.vorsorgeText][
                    "100"
                ].fond6;
            }
            return result;
        },
    },
};
